import React from 'react';
import { MdClose } from 'react-icons/md';
import { PiWarningBold } from "react-icons/pi";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, licenseName }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-admin">
        <div className="modal-header">
         <h6><span className='warning-icon me-1'><PiWarningBold/></span>Delete License</h6>
          <button className="close-btn" onClick={onClose}>
            <MdClose />
          </button>        
        </div>
        
        <div className="modal-body">
          <p>Are you sure you want to delete <strong>{licenseName}</strong>?</p>
        </div>
        
        <div className="modal-footer">
          <button className="delete-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;